import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { STORAGE_KEYS } from '../constants/storage-keys';
import { AuthService } from '../services/auth.service';

/**
 * Attaches the bearer token to every outgoing request. When the API responds
 * with 401 (expired session) or 403 (access denied), delegates to
 * AuthService.handleSessionExpired() which clears all auth state (storage +
 * signals) and redirects to login so the user must re-authenticate.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = localStorage.getItem(STORAGE_KEYS.accessToken);

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        auth.handleSessionExpired();
      }
      return throwError(() => error);
    })
  );
};
